import React, { memo, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { COUNTRIES } from '../../components/PersonalArea/PersonalAreaAddress/queriesAddress';
import { countryCode } from '../../utils/checkout';

const CountryOptions = ({ onFetch }) => {
  const { data } = useQuery(COUNTRIES);

  useEffect(() => {
    if (data && onFetch) {
      onFetch();
    }
  }, [data]);

  if (!data) {
    return null;
  }

  const sorted = [...data.countries].sort((lhs, rhs) => {
    return lhs.full_name_locale < rhs.full_name_locale ? -1 : 1;
  });

  return sorted.map(
      ({ id, full_name_locale: fullName }) =>
          id !== countryCode && (
              <option key={id} value={id}>
                {fullName}
              </option>
          ),
  );
};

export default memo(CountryOptions);